import { render, staticRenderFns } from "./MessageboxEnhanced.vue?vue&type=template&id=3816e430"
import script from "./MessageboxEnhanced.vue?vue&type=script&lang=js"
export * from "./MessageboxEnhanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports